import { BaseComponent } from './BaseComponent';
import { ComponentsNamespaceErrorCode, createComponentsNamespaceError, } from '../errors';
export class UnknownComponent extends BaseComponent {
    constructor(compRef, _unknownCompType) {
        super();
        this.compRef = compRef;
        this.type = null;
    }
    getProp(_prop) {
        throw createComponentsNamespaceError(ComponentsNamespaceErrorCode.UnknownComponentGetProp, 'only text and image components are supported');
    }
    setProp() {
        throw createComponentsNamespaceError(ComponentsNamespaceErrorCode.UnknownComponentSetProp, 'only text and image components are supported');
    }
}
//# sourceMappingURL=UnknownComponent.js.map